import { useReducedMotion } from 'framer-motion';

//* DonatingPortal·SearchBar와 같은 값 — expo-out은 구간 20%에서 이미 불투명도 75%에 닿아 '툭' 나타난다
const FADE_DURATION = 0.24;
const EXIT_DURATION = 0.2;
const STAGGER_SECONDS = 0.07;
const ROW_DELAY_SECONDS = 0.02;
const ROW_STAGGER_SECONDS = 0.03;
const ROW_FADE_DURATION = 0.16;

export const useFade = () => {
  const speed = useReducedMotion() ? 0 : 1;

  return (order = 0) =>
    ({
      initial: { opacity: 0 },
      animate: {
        opacity: 1,
        transition: {
          duration: FADE_DURATION * speed,
          delay: order * STAGGER_SECONDS * speed,
          ease: 'easeOut',
        },
      },
      exit: {
        opacity: 0,
        transition: { duration: EXIT_DURATION * speed, ease: 'easeIn' },
      },
    }) as const;
};

export const useRowFade = () => {
  const speed = useReducedMotion() ? 0 : 1;

  return (index: number) =>
    ({
      initial: { opacity: 0 },
      animate: {
        opacity: 1,
        transition: {
          duration: ROW_FADE_DURATION * speed,
          delay: (ROW_DELAY_SECONDS + index * ROW_STAGGER_SECONDS) * speed,
          ease: 'easeOut',
        },
      },
      exit: {
        opacity: 0,
        transition: { duration: EXIT_DURATION * speed, ease: 'easeIn' },
      },
    }) as const;
};
